import {
    isValidNumber,
    clamp,
    parseStringToStringNumber,
    toMaxPrecision,
} from "./numbers";

describe("number utils", () => {
    describe("isValidNumber", () => {
        it("should return false for non-numeric values", () => {
            expect(isValidNumber(null)).toBeFalsy();
            expect(isValidNumber(undefined)).toBeFalsy();
            expect(isValidNumber({})).toBeFalsy();
            expect(isValidNumber("1")).toBeFalsy();
            expect(isValidNumber(Number.NaN)).toBeFalsy();
        });

        it("should return true for numeric values", () => {
            expect(isValidNumber(-1)).toBeTruthy();
            expect(isValidNumber(0)).toBeTruthy();
            expect(isValidNumber(1)).toBeTruthy();
        });
    });

    describe("clamp", () => {
        it("should clamp upper bound", () => {
            expect(clamp(10, 0, 1)).toEqual(1);
        });

        it("should clamp lower bound", () => {
            expect(clamp(-10, 0, 1)).toEqual(0);
        });
        it("should clamp only defined bounds", () => {
            expect(clamp(2, 0, null)).toEqual(2);
            expect(clamp(-1, null, 1)).toEqual(-1);
        });
    });

    describe("parseStringToStringNumber", () => {
        it("should keep signed numbers", () => {
            expect(parseStringToStringNumber("+1")).toEqual("+1");
            expect(parseStringToStringNumber("-1")).toEqual("-1");
        });
        it("should remove non-numberic characters", () => {
            expect(parseStringToStringNumber("A z123b")).toEqual("123");
        });
        it("should keep dot as decimal separator", () => {
            expect(parseStringToStringNumber("1.002", "en")).toEqual("1.002");
            expect(parseStringToStringNumber("1,002", "en")).toEqual("1002");
        });

        it("should replace decimal separator depending on locale", () => {
            expect(parseStringToStringNumber("1,002", "de")).toEqual("1.002");
            expect(parseStringToStringNumber("1.002", "de")).toEqual("1002");
        });
    });

    describe("toMaxPrecision", () => {
        it("should round number to precision", () => {
            expect(toMaxPrecision(1.5, 0)).toEqual(2);
            expect(toMaxPrecision(1.53, 1)).toEqual(1.5);
        });
    });
});
